export default __webpack_public_path__ + "static/media/tim-icon-2.7fc25947.svg";